import { TFunction } from "i18next";
import { Text } from "@pentabd/ui";

export const Column = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 2,
      key: "id",
      name: "ক্র: নং",
      render: (id: number) => (
        <Text color="subtitle1" className="text-nowrap">
          {id}
        </Text>
      ),
    },
    {
      id: 3,
      key: "employeeGeneralInfo",
      name: <Text className="text-nowrap">কর্মকর্তা/কর্মচারীর নাম</Text>,
      render: (employeeGeneralInfo: string) => (
        <Text color="subtitle1">{employeeGeneralInfo}</Text>
      ),
    },
    {
      id: 8,
      key: "positionNameBn",
      name: <Text className="text-nowrap">পদবী</Text>,
      render: (positionNameBn: string) => (
        <Text color="subtitle1">{positionNameBn}</Text>
      ),
    },
    {
      id: 9,
      key: "officeNameBn",
      name: <Text className="text-nowrap">সর্বশেষ কর্মস্থল</Text>,
      render: (officeNameBn: string) => (
        <Text color="subtitle1">{officeNameBn}</Text>
      ),
    },
    {
      id: 4,
      key: "fatherNameAndPermanentAddress",
      name: (
        <Text className="text-nowrap">পিতা/স্বামীর নাম ও স্থায়ী ঠিকানা</Text>
      ),
      render: (fatherNameAndPermanentAddress: string) => (
        <Text color="subtitle1">{fatherNameAndPermanentAddress}</Text>
      ),
    },

    {
      id: 5,
      key: "presentAddressAndPhone",
      name: <Text className="text-nowrap">বর্তমান ঠিকানা ও ফোন নম্বর</Text>,
      render: (presentAddressAndPhone: string) => (
        <Text color="subtitle1">{presentAddressAndPhone}</Text>
      ),
    },
    {
      id: 6,
      key: "prlDate",
      name: "পিআরএল শুরুর তারিখ",
      render: (prlDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {prlDate}
        </Text>
      ),
    },
    {
      id: 7,
      key: "pensionDate",
      name: "পেনশন শুরুর তারিখ",
      render: (pensionDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {pensionDate}
        </Text>
      ),
    },
  ];
};
